module.exports = {
	...require('./MuiGlobalStyles.styles'),
	...require('./MuiTableStyles.styles'),
	...require('./MuiAccordion.styles'),
	...require('./MuiStyles'),
};
